import { Checkbox, FormControlLabel } from '@mui/material'
import css from './HoraCheckbox.module.css'

const OCUPACION_BAJA = 8
const OCUPACION_MEDIA = 15
const OCUPACION_ALTA = 20

const getOcupacion = count => {
  if (count < OCUPACION_BAJA) return 'baja'
  if (count < OCUPACION_MEDIA) return 'media'
  if (count < OCUPACION_ALTA) return 'alta'
  return 'critica'
}

export const HoraCheckbox = ({
  fecha,
  hora,
  horas,
  asistencias,
  onChange,
  carga
}) => {
  const count = carga?.[fecha]?.[hora]
  const ocupacion = count !== undefined ? getOcupacion(count) : undefined
  return (
    <FormControlLabel
      control={
        <Checkbox
          checked={
            horas.some(h => h.fecha === fecha && h.hora === hora) ||
            asistencias.some(a => a.fecha === fecha && a.hora === hora)
          }
          onChange={e =>
            onChange(e, { fecha, hora, checked: e.target.checked })
          }
        />
      }
      label={
        <span className={css.horaLabel} data-ocupacion={ocupacion}>
          {hora}
        </span>
      }
      disabled={asistencias.some(a => a.fecha === fecha && a.hora === hora)}
    />
  )
}
